import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux"
import configureStore from "./redux/configureStore";
import {getTokenFromLocalStorage, roles} from "./utils/auth";
import {SnackbarProvider} from "notistack";
import Notifier from "./components/Notifier";
import jwt_decode from "jwt-decode"
import AlertsHub from "./components/AlertsHub";

const setUpInitialState = () => {

    let initialState = {};
    let auth = getTokenFromLocalStorage();

    //Decode user date from token
    if (auth.token) {
        let tokenData = jwt_decode(auth.token);
        auth = {
            ...tokenData,
            ...auth
        }
    }
    initialState.auth = auth;
    return initialState;
};

const store = configureStore(setUpInitialState());

ReactDOM.render(
    <Provider store={store}>
        <SnackbarProvider maxSnack={3}
                          hideIconVariant
                          autoHideDuration={2000}
                          anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                          }}>
            <App/>
            <Notifier/>
            {/*<SignalR/>*/}
            <AlertsHub/>
        </SnackbarProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
